<div class="container" *ngIf="timeChallengeService.showCountdown || (timeChallengeService.challenge && !timeChallengeService.acceptedChallenge)">
    <div *ngIf="timeChallengeService.challenge"
        class="time-challenge"
        [style.background-image]="'url(https://play.vidyard.com/' + timeChallengeService.challenge.i18nThumbDetail[translate.currentLang.toUpperCase()] + '.jpg)'">
    </div>
    <h2>{{timeChallengeService.challenge.i18nTitle[translate.currentLang.toUpperCase()]}}</h2>
    <p class="date">{{timeChallengeService.formatDateAsString(timeChallengeService.challenge.startDate)}} -
        {{timeChallengeService.formatDateAsString(timeChallengeService.challenge.endDate)}}</p>
    <p>{{timeChallengeService.challenge.i18nDescription[translate.currentLang.toUpperCase()]}}</p>

    <div
      *ngIf="timeChallengeService.showCountdown && timeChallengeService.acceptedChallenge && timeChallengeService.challenge && !showChangeChall"
      [style.margin-bottom.px]="timeChallengeService.challenge && timeChallengeService.challenge.challenges.length > 1 ? 75 : null">
      <div class="week-container">
        <swiper-container [slidesPerView]="2.5">
          <swiper-slide
            *ngFor="let slide of timeChallengeService.challenge.challenges[timeChallengeService.acceptedChallenge.challengeNumber].weeks; let i = index">
            <div class="slide">
              <div class="week-chip" [class.week-selected]="selectedWeek === i" (click)="selectedWeek = i">
                {{"BANNER_CHALLENGE.WEEK" | translate}} {{i+1}}
                <mat-icon svgIcon="mat:lock" *ngIf="checkUnlockWeekDate(slide.publishDate)"></mat-icon>
              </div>
            </div>
          </swiper-slide>
        </swiper-container>
      </div>
      <div class="video-container">
        <div class="item-video"
          *ngFor="let video of timeChallengeService.challenge.challenges[timeChallengeService.acceptedChallenge.challengeNumber].weeks[selectedWeek].videos; let k = index">
          <img [src]="'https://play.vidyard.com/' + video.videoId[translate.currentLang.toUpperCase()] + '.jpg'" alt=""
            (click)="checkUnlockWeekDate(timeChallengeService.challenge.challenges[timeChallengeService.acceptedChallenge.challengeNumber].weeks[selectedWeek].publishDate) ? null : openVideo(video)">
          <div style="width: 100%;">
            <div class="video-day-container">
              <p class="video-day"
                (click)="checkUnlockWeekDate(timeChallengeService.challenge.challenges[timeChallengeService.acceptedChallenge.challengeNumber].weeks[selectedWeek].publishDate) ? null : openVideo(video)">
                {{"BANNER_CHALLENGE.DAY" | translate}} {{k+1}}</p>
              <img *ngIf="!checkVideosWatched(selectedWeek,k, video.videoId['IT'])"
                (click)="setVideoWatched(k, selectedWeek, video.videoId['IT'], video.i18nTitle[translate.currentLang.toUpperCase()])"
                src="../../../assets/img/thunderbolt_outline_violet.svg" alt="">
              <img *ngIf="checkVideosWatched(selectedWeek,k, video.videoId['IT'])"
                src="../../../../assets/img/thunderbolt_violet.svg" alt="">
            </div>
            <p
              (click)="checkUnlockWeekDate(timeChallengeService.challenge.challenges[timeChallengeService.acceptedChallenge.challengeNumber].weeks[selectedWeek].publishDate) ? null : openVideo(video)">
              {{video.i18nTitle[translate.currentLang.toUpperCase()]}}</p>
          </div>
          <div class="locked-video"
            *ngIf="checkUnlockWeekDate(timeChallengeService.challenge.challenges[timeChallengeService.acceptedChallenge.challengeNumber].weeks[selectedWeek].publishDate)">
            <div class="lock-img-container">
              <img src="../../assets/img/Lucchetto.png" alt="" class="lock-icon">
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="challenges-container" *ngIf="(timeChallengeService.challenge && !timeChallengeService.acceptedChallenge) || timeChallengeService.acceptedChallenge && showChangeChall" [style.margin-bottom.px]="timeChallengeService.challenge && timeChallengeService.challenge.challenges.length > 1 ? 60 : null">
        <div class="chall-list-item" *ngFor="let item of timeChallengeService.challenge.challenges; let k = index" (click)="timeChallengeService.selectedChallenge = k;">
            <div class="custom-radio">
                <div class="inner-radio" *ngIf="k === timeChallengeService.selectedChallenge"></div>
            </div>
            <p>
                {{item.i18nTitle[translate.currentLang.toUpperCase()]}}
            </p>
        </div>
    </div>
    <div class="footer-position"
        *ngIf="timeChallengeService.acceptedChallenge && timeChallengeService.challenge.challenges.length > 1|| !timeChallengeService.acceptedChallenge">
        <button class="its-button" *ngIf="!timeChallengeService.acceptedChallenge" (click)="acceptChallenge()">
            <span *ngIf="!spinner">{{"BANNER_CHALLENGE.JOIN_BTN" | translate}}</span>
            <ion-spinner name="circular" *ngIf="spinner" style="height: 14px;"></ion-spinner>
        </button>
        <button class="its-button" *ngIf="timeChallengeService.acceptedChallenge" (click)="acceptChallenge()"
            [disabled]="timeChallengeService.acceptedChallenge.challengeNumber === timeChallengeService.selectedChallenge">
            <span *ngIf="!spinner">{{"BANNER_CHALLENGE.CHANGE_CHALL_BTN" | translate}}</span>
            <ion-spinner name="circular" *ngIf="spinner" style="height: 14px;"></ion-spinner>
        </button>
    </div>
</div>
<div class="container" *ngIf="!timeChallengeService.showCountdown && timeChallengeService.acceptedChallenge">
    <h2>{{timeChallengeService.challenge.i18nTitle[translate.currentLang.toUpperCase()]}}</h2>
    <h3 class="sub-chall-name">{{timeChallengeService.challenge.challenges[timeChallengeService.acceptedChallenge.challengeNumber].i18nTitle[translate.currentLang.toUpperCase()]}}</h3>
    <p class="date">{{timeChallengeService.formatDateAsString(timeChallengeService.challenge.startDate)}} -
        {{timeChallengeService.formatDateAsString(timeChallengeService.challenge.endDate)}}</p>
    <div class="week-container">
        <swiper-container [slidesPerView]="2.5">
            <swiper-slide
                *ngFor="let slide of timeChallengeService.challenge.challenges[timeChallengeService.acceptedChallenge.challengeNumber].weeks; let i = index">
                <div class="slide">
                    <div class="week-chip" [class.week-selected]="selectedWeek === i" (click)="selectedWeek = i">
                        {{"BANNER_CHALLENGE.WEEK" | translate}} {{i+1}}
                        <mat-icon svgIcon="mat:lock" *ngIf="checkUnlockWeekDate(slide.publishDate)"></mat-icon>
                    </div>
                </div>
            </swiper-slide>
        </swiper-container>
    </div>
    <div class="video-container">
        <div class="item-video" *ngFor="let video of timeChallengeService.challenge.challenges[timeChallengeService.acceptedChallenge.challengeNumber].weeks[selectedWeek].videos; let k = index">
            <img [src]="'https://play.vidyard.com/' + video.videoId[translate.currentLang.toUpperCase()] + '.jpg'" alt="" (click)="checkUnlockWeekDate(timeChallengeService.challenge.challenges[timeChallengeService.acceptedChallenge.challengeNumber].weeks[selectedWeek].publishDate) ? null : openVideo(video)">
            <div style="width: 100%;">
                <div class="video-day-container">
                    <p class="video-day" (click)="checkUnlockWeekDate(timeChallengeService.challenge.challenges[timeChallengeService.acceptedChallenge.challengeNumber].weeks[selectedWeek].publishDate) ? null : openVideo(video)">{{"BANNER_CHALLENGE.DAY" | translate}} {{k+1}}</p>
                    <img *ngIf="!checkVideosWatched(selectedWeek,k, video.videoId['IT'])" (click)="setVideoWatched(k, selectedWeek, video.videoId['IT'], video.i18nTitle[translate.currentLang.toUpperCase()])" src="../../../assets/img/thunderbolt_outline_violet.svg" alt="">
                    <img *ngIf="checkVideosWatched(selectedWeek,k, video.videoId['IT'])" src="../../../../assets/img/thunderbolt_violet.svg" alt="">
                </div>
                <p (click)="checkUnlockWeekDate(timeChallengeService.challenge.challenges[timeChallengeService.acceptedChallenge.challengeNumber].weeks[selectedWeek].publishDate) ? null : openVideo(video)">{{video.i18nTitle[translate.currentLang.toUpperCase()]}}</p>
            </div>
            <div class="locked-video" *ngIf="checkUnlockWeekDate(timeChallengeService.challenge.challenges[timeChallengeService.acceptedChallenge.challengeNumber].weeks[selectedWeek].publishDate)">
                <div class="lock-img-container">
                    <img src="../../assets/img/Lucchetto.png" alt="" class="lock-icon">
                </div>
            </div>
        </div>
    </div>
</div>
